var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"pop-in"}},[(_vm.show)?_c('div',{staticClass:"bxp-back-to-top",on:{"click":function($event){return _vm.backToTop()}}},[_c('v-icon',[_vm._v("fa-chevron-up")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }